// Certidões de Distribuição positivas — usado pelos 7 pedidos que exigem as
// certidões Estadual e Federal (Inscrição Originária/Suplementar/Transferência/
// Estagiário, Transformação Suplementar/Transferência, Reativação e Prorrogação
// de Estágio). A pessoa indica na etapa de Termos qual certidão deu positiva
// (termosStep(..., { certidoesPositivas: true })) e, pra cada uma marcada, a
// respectiva Certidão de Objeto e Pé vira documento obrigatório
// (DOCUMENTOS_OBJETO_E_PE, no documentConfig.conditional do pedido).

const CERTIDAO_ESTADUAL_POSITIVA = 'certidaoEstadualPositiva';
const CERTIDAO_FEDERAL_POSITIVA = 'certidaoFederalPositiva';

export const certidoesPositivasSection = () => ({
  title: 'Alguma das suas Certidões de Distribuição resultou positiva?',
  fields: [
    { type: 'checkbox', name: CERTIDAO_ESTADUAL_POSITIVA, label: 'Certidão Estadual positiva' },
    { type: 'checkbox', name: CERTIDAO_FEDERAL_POSITIVA, label: 'Certidão Federal positiva' },
    {
      type: 'checkbox',
      name: 'declaroCertidoesPositivas',
      label: 'DECLARO que a(s) certidão(ões) indicada(s) acima resultou(aram) positiva(s) e que estou anexando a respectiva Certidão de Objeto e Pé, ciente de que a ausência ou irregularidade desse documento acarretará o indeferimento do meu pedido de inscrição.',
      required: true,
      showWhenAny: [
        { field: CERTIDAO_ESTADUAL_POSITIVA, value: true },
        { field: CERTIDAO_FEDERAL_POSITIVA, value: true }
      ]
    }
  ]
});

// tipoDocumentoProcesso 564/565: TipoDocumento cadastrado no legado e vinculado
// (ModeloRequerimentoDocumento) aos modelos dos 7 pedidos.
export const DOCUMENTOS_OBJETO_E_PE = [
  {
    id: 'certidaoObjetoPeEstadual', tipoDocumentoProcesso: 564,
    name: 'Certidão de Objeto e Pé – Justiça Estadual',
    description: 'Obrigatória quando alguma Certidão Estadual resultou positiva. Havendo mais de um processo, juntar todas em arquivo único PDF.',
    conditional: true,
    required: true,
    dependsOn: { field: CERTIDAO_ESTADUAL_POSITIVA, value: true }
  },
  {
    id: 'certidaoObjetoPeFederal', tipoDocumentoProcesso: 565,
    name: 'Certidão de Objeto e Pé – Justiça Federal',
    description: 'Obrigatória quando alguma Certidão Federal resultou positiva. Havendo mais de um processo, juntar todas em arquivo único PDF.',
    conditional: true,
    required: true,
    dependsOn: { field: CERTIDAO_FEDERAL_POSITIVA, value: true }
  }
];
